module.exports = __webpack_public_path__ + "img/f27.4be6c471.png";